import { render, staticRenderFns } from "./adminCountries.vue?vue&type=template&id=52a98a82&"
import script from "./adminCountries.vue?vue&type=script&lang=js&"
export * from "./adminCountries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports